// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ReactiveTable-components-states-common-module__box--y698s {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 48px 24px;
}
.src-components-ReactiveTable-components-states-common-module__loadingContent--bNaBr {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: white;
  opacity: 0.3;
}
/*# sourceMappingURL=common.module.css.map */`, "",{"version":3,"sources":["webpack://./common.module.less","webpack://./src/components/ReactiveTable/components/states/common.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;ACCF;ADEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;ACAF;AACA,4CAA4C","sourcesContent":[".box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  padding: 48px 24px;\n}\n\n.loadingContent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n  background-color: white;\n  opacity: 0.3;\n}\n",".box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  padding: 48px 24px;\n}\n.loadingContent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n  background-color: white;\n  opacity: 0.3;\n}\n/*# sourceMappingURL=common.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-components-ReactiveTable-components-states-common-module__box--y698s`;
export var loadingContent = `src-components-ReactiveTable-components-states-common-module__loadingContent--bNaBr`;
export default ___CSS_LOADER_EXPORT___;
